'use client';

import { memo } from 'react';
import { Box, Group, Stack, StackProps } from '@mantine/core';
import classes from './Layout.module.css';

export const RightSidebar = memo(({ children, ...props }: StackProps) => {
  return (
    <Stack gap={0} {...props}>
      {children}
    </Stack>
  );
});

export const RightSidebarHeader = memo(({ children }: { children: React.ReactNode }) => {
  return (
    <Group gap={0} h="44px" mih="44px" px="sm" justify="space-between" wrap="nowrap">
      {children}
    </Group>
  );
});

export const RightSidebarPortal = memo(() => {
  return <Box className={classes.rightSidebar} id="right-sidebar-portal" />;
});
